var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3H3.5C3.22386 3 3 3.22386 3 3.5V6.5C3 6.77614 3.22386 7 3.5 7H6.5C6.77614 7 7 6.77614 7 6.5V3.5C7 3.22386 6.77614 3 6.5 3Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H9.5C9.22386 3 9 3.22386 9 3.5V6.5C9 6.77614 9.22386 7 9.5 7H12.5C12.7761 7 13 6.77614 13 6.5V3.5C13 3.22386 12.7761 3 12.5 3Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.33301H3.5C3.22386 9.33301 3 9.55687 3 9.83301V12.833C3 13.1092 3.22386 13.333 3.5 13.333H6.5C6.77614 13.333 7 13.1092 7 12.833V9.83301C7 9.55687 6.77614 9.33301 6.5 9.33301Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.972 13.8937C13.954 13.9261 13.9281 13.953 13.8969 13.9718C13.8657 13.9905 13.8303 14.0003 13.7943 14.0003H8.87094C8.83495 14.0003 8.7996 13.9904 8.76845 13.9717C8.73729 13.9529 8.71143 13.926 8.69345 13.8936C8.67547 13.8612 8.66601 13.8244 8.66602 13.787C8.66602 13.7495 8.6755 13.7128 8.6935 13.6804C9.08403 12.9783 9.68586 12.4749 10.3882 12.2363C10.0408 12.0213 9.77088 11.6936 9.61991 11.3036C9.46893 10.9136 9.44525 10.4828 9.55251 10.0775C9.65976 9.67214 9.89201 9.31461 10.2136 9.0598C10.5352 8.80499 10.9283 8.66699 11.3326 8.66699C11.7369 8.66699 12.1301 8.80499 12.4516 9.0598C12.7732 9.31461 13.0055 9.67214 13.1127 10.0775C13.22 10.4828 13.1963 10.9136 13.0453 11.3036C12.8944 11.6936 12.6244 12.0213 12.277 12.2363C12.9794 12.4749 13.5812 12.9783 13.9717 13.6804C13.9898 13.7128 13.9993 13.7495 13.9993 13.787C13.9994 13.8244 13.99 13.8612 13.972 13.8937Z",
    fill: "#838FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyapp);
export default __webpack_public_path__ + "static/media/myapp.a8ab8239f61f713c1a21c8f6071c6d3a.svg";
export { ForwardRef as ReactComponent };